import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bc63f13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "window-context" }
const _hoisted_2 = { class: "window-footer" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" OK ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!
  const _component_TheLoginForm = _resolveComponent("TheLoginForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_ButtonIcon, {
        onClick: _ctx.onBookmarkItem,
        onKeydown: _withKeys(_withModifiers(_ctx.onBookmarkItem, ["prevent"]), ["space","enter"]),
        icon: _ctx.bookmarked ? _ctx.ICON_STYLE_BOOKMARK_FILL : _ctx.ICON_STYLE_BOOKMARK,
        "aria-label": _ctx.bookmarked ? _ctx.$t('mycollection.bookmarkToRemove') : _ctx.$t('mycollection.bookmarkToAdd'),
        styled: "is-none",
        class: _normalizeClass([_ctx.bookmarkButtonStyle, "button-bookmark"]),
        role: "img"
      }, null, 8, ["onClick", "onKeydown", "icon", "aria-label", "class"])
    ]),
    (_ctx.isAnnotationModalShow)
      ? (_openBlock(), _createBlock(_component_ModalWindow, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isAnnotationModalShow = false)),
          heading: _ctx.$t(''),
          class: "window-modal window-annotation window-modal-login-annotation-modal"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, [
              _createTextVNode(_toDisplayString(_ctx.$t('mycollection.loginGuidanceMessageStart')) + " ", 1),
              _createVNode(_component_AppButton, {
                styled: "is-none",
                class: "button-link",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.isLogoutModalShow = true; _ctx.isAnnotationModalShow = false}),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => {_ctx.isLogoutModalShow = true; _ctx.isAnnotationModalShow = false}, ["prevent"]), ["space","enter"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('mycollection.loginGuidanceMessageLink')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('mycollection.loginGuidanceMessageEnd')), 1)
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_AppButton, {
                styled: "is-accent",
                class: "display-block",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isAnnotationModalShow = false)),
                onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.isAnnotationModalShow = false), ["prevent"]), ["space","enter"]))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["heading"]))
      : _createCommentVNode("", true),
    (_ctx.isLogoutModalShow)
      ? (_openBlock(), _createBlock(_component_ModalWindow, {
          key: 1,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isLogoutModalShow = false)),
          heading: _ctx.$t('parts.login'),
          class: "window-modal window-login-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TheLoginForm, { onClose: _ctx.onLogin }, null, 8, ["onClose"])
          ]),
          _: 1
        }, 8, ["heading"]))
      : _createCommentVNode("", true)
  ], 64))
}